import MuiCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import { typedMemo } from '@utils';
import React from 'react';

interface CardProps {
  label?: string;
  children: React.ReactNode;
  variant?: 'elevation' | 'outlined';
}

export const Card = typedMemo(
  ({ label, children, variant = 'elevation' }: Readonly<CardProps>) => {
    return (
      <MuiCard variant={variant}>
        {label && (
          <CardHeader
            disableTypography={false}
            title={label}
            slotProps={{ title: { variant: 'body1' } }}
          ></CardHeader>
        )}
        <CardContent>{children}</CardContent>
      </MuiCard>
    );
  },
);
